const serviceData = [
  {
    id: 1,
    title: "City Transfer",
    icon: "ri-map-pin-2-line",
    desc: "Efficient city transfers with [Your Company Name]. Timely, reliable, and comfortable rides for business or leisure. Leave transportation worries behind.",
  },

  {
    id: 2,
    title: "Whole  City Tour",
    icon: "ri-community-line",
    desc: "Explore the city hassle-free with our Whole City Tour. Friendly drivers, iconic landmarks, and hidden gems. An immersive and personalized experience at your pace.",
  },

  {
    id: 3,
    title: "Unlimited Miles Car Rental",
    icon: "ri-roadster-line",
    desc: "Drive limitlessly with our Unlimited Miles Car Rental. Diverse fleet, straightforward pricing for road trips or extended use. No restrictions, just pure driving pleasure.",
  },

  {
    id: 4,
    title: "Fast & Easy Booking",
    icon: "ri-timer-flash-line",
    desc: "Quick and hassle-free booking with UNION SERVICES. User-friendly platform, seamless experience. Save time and secure your ride in just a few clicks.",
  },

  {
    id: 5,
    title: "Many Pickup Locations",
    icon: "ri-map-pin-line",
    desc: "Convenient pickup locations throughout the city. Select the closest one at home, the office, or landmarks. We've got you covered.",
  },

  {
    id: 6,
    title: "Airport Transfer",
    icon: "ri-flight-takeoff-line",
    desc: "Stress-free Airport Transfers. Punctual and professional drivers ensure on-time departures or comfortable arrivals. Reliable and comfortable journeys every time.",
  },
];

export default serviceData;
